import { useState } from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';
import './NudgeBanner.css';

// Re-engagement in-app notice (shared-docs/re-engagement-nudges.md Channel 2).
// Renders at most ONE dismissible banner when the launch-time /api/subscription
// response carries an inAppNudge the user hasn't dismissed. Subtle, never
// blocking; dismiss is tracked per-nudge-id in localStorage.
function isDismissed(id) {
  try {
    return Boolean(localStorage.getItem(`nudgeDismissed:${id}`));
  } catch {
    return false;
  }
}

export default function NudgeBanner() {
  const { inAppNudge } = useSubscription();
  const [dismissed, setDismissed] = useState(false);

  if (!inAppNudge?.id || dismissed || isDismissed(inAppNudge.id)) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(`nudgeDismissed:${inAppNudge.id}`, '1');
    } catch {
      // Private mode — session-only dismiss via state below
    }
    setDismissed(true);
  };

  return (
    <div className="nudge-banner" role="status">
      <div className="nudge-banner__text">
        <span className="nudge-banner__title">{inAppNudge.title}</span>
        <span className="nudge-banner__body">{inAppNudge.body}</span>
      </div>
      <button
        type="button"
        className="nudge-banner__close"
        aria-label="Dismiss"
        onClick={dismiss}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
}
